import { Language } from "../../../tolgee.config.js";

export const fallbackLanguage = Language["cs-CZ"];
